import classNames from "classnames";
import React from "react";

import connect from "../../../../../../../i18n/connect";
import useIsDesktop from "../../../../hooks/useIsDesktop";
import BlackFriday from "../../assets/black_friday.png";
import BlackFridayOneLine from "../../assets/black_friday_one_line.png";
import CountdownTimer from "../CountdownTimer";

const BlackFridayPlanBanner = ({ translate }) => {
  const isDesktop = useIsDesktop();

  return (
    <div
      className={classNames(
        "rounded-1xl flex bg-black-3 gap-6 max-w-7xl mx-auto",
        {
          "px-12 py-3 mb-11 justify-between items-center": isDesktop,
          "pt-4 px-5 flex-col items-start mb-19 pb-6": !isDesktop
        }
      )}
    >
      <div>
        <img
          className={classNames("max-w-full", {
            "mb-1.5": isDesktop,
            "mb-4": !isDesktop
          })}
          src={isDesktop ? BlackFridayOneLine : BlackFriday}
          width={isDesktop ? 423 : 250}
          alt={translate("lp_black-friday_section-3_banner_image-alt")}
        />
        <p
          className={classNames("mb-0 opacity-85", {
            "text-lg": isDesktop,
            "text-base": !isDesktop
          })}
          dangerouslySetInnerHTML={{
            __html: translate("lp_black-friday_section-3_banner_paragraph")
          }}
        />
      </div>
      <CountdownTimer
        targetTime={Number(translate("lp_black-friday_time"))}
        size={isDesktop ? "big" : "default"}
      />
    </div>
  );
};

export default connect()(BlackFridayPlanBanner);
